import { get } from '@atlassian/jira-common-rest/src/api/1.0/labels/suggest/rest.tsx';
import type { SuggestedLabelsResponse } from '@atlassian/jira-common-rest/src/api/1.0/labels/suggest/types.tsx';
import type { LabelOption } from '../model/index.tsx';

export const validationErrorMessage =
	'labels validation failed. must not contain spaces or be more than 255 characters';

const transformLabels = (response: SuggestedLabelsResponse): LabelOption[] => {
	// @ts-expect-error - TS2339 - Property 'errorMessages' does not exist on type 'SuggestedLabelsResponse'.
	if (response.suggestions || !response.errorMessages) {
		return response.suggestions.map((suggestion) => ({
			label: suggestion.label,
			value: suggestion.label,
			...(suggestion.color ? { color: suggestion.color } : {}),
		}));
	}
	throw new Error(validationErrorMessage);
};

export const labelsService = (
	query: string,
	customFieldId: string | undefined,
): Promise<LabelOption[]> =>
	get({
		query,
		customFieldId,
	}).then(transformLabels);
